/* ============================================================
   Yummii Yummii — evergreen quiz engine, v2
   ES5, no dependencies, no build step.
   Mounted via window.YYQuiz.mount(rootEl) onto a
   <div class="yyq" data-yyq data-frame="popup|page" …> element
   produced by snippets/yy-quiz-markup.liquid.

   Task 16 — v2 content and flow rebuild, per
   docs/superpowers/specs/2026-08-25-yummii-evergreen-quiz-addendum-3.md
   (§A3.2 is the scope list) and .superpowers/sdd/…/spec-v2-client.md
   DEL 2 (the quiz) and DEL 3 (the result page).

   Flow (addendum 3 §A3.2): seven questions in three acts, an aha
   screen after each of the three fact questions, image multi-select
   (Q4), frequency with a score multiplier (Q5), who-for multi-select
   (Q6), lunchboxes/week (Q7), a 2.4s calculation screen, then the
   result: three weighted hotspots, a score-dependent headline, a
   bundle.

   FLOW = intro, fact0, aha0, fact1, aha1, fact2, aha2,
          cards, freq, who, boxes, calc, result
   The seven "questions" for progress/back purposes are:
   fact0, fact1, fact2, cards, freq, who, boxes — aha/calc/result are
   not part of that count (spec: "Aha-skærmene rykker den ikke").
   ============================================================ */
window.YYQuiz = (function(){
  "use strict";
  /* Tekster fra sprogfilerne (yy.quiz.*), udskrevet som window.YYQ_T af
     snippets/yy-quiz-markup.liquid, saa Translate & Adapt kan oversaette dem. */
  function T(key){ var d = window.YYQ_T || {}; return d[key] != null ? String(d[key]) : key; }

  function parse(el, key, fallback){
    try {
      var v = JSON.parse(el.getAttribute(key));
      return v || fallback;
    } catch(e){ return fallback; }
  }

  /* ---------- Klaviyo tracking (addendum 2 §A2.3, expanded per addendum 3 §A3.2) ----------
     Tracking is strictly secondary — a missing or failing Klaviyo must
     never block the quiz, so every call is guarded. */
  function klaviyoTrack(name, props){
    try{
      if(window.klaviyo && typeof window.klaviyo.push === "function"){
        window.klaviyo.push(["track", name, props]);
      }
    }catch(e){ /* tracking er sekundært til at kunden kommer igennem */ }
  }

  function shuffle(arr){
    var a = arr.slice();
    for(var i = a.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  var QUESTION_ORDER = ["fact0","fact1","fact2","cards","freq","who","boxes"];
  var FLOW = ["intro","fact0","aha0","fact1","aha1","fact2","aha2","cards","freq","who","boxes","calc","result"];
  var LETTERS = ["A","B","C","D","E","F","G","H"];
  var DONE_KEY = "yy_quiz_done";

  function mount(root){
    if(!root || root.__yyqMounted) return;
    root.__yyqMounted = true;

    var FACTS = parse(root, "data-facts", []);
    var CARDS = parse(root, "data-cards", []);
    var FREQ  = parse(root, "data-freq", []);
    var WHO   = parse(root, "data-who", []);
    var BOXES = parse(root, "data-boxes", []);
    var HOTSPOTS = parse(root, "data-hotspots", {});
    var FRAME = root.getAttribute("data-frame");
    var LOGO_URL = root.getAttribute("data-logo-url") || "";
    var CLUB_URL = root.getAttribute("data-club-url") || "/pages/klub";
    var SOURCE_LINE = root.getAttribute("data-source-line") || "";
    /* ---------- gave-løfte + delt billedlayout (addendum 4) ----------
       GIFT_PILL/GIFT_MIN are read from the SAME data attributes on both
       frames — the value comes from a setting with the identical id in
       both section schemas, so the page and the pop-up can never end up
       promising different things. */
    var GIFT_MIN = root.getAttribute("data-gift-min") || "100";
    var GIFT_PILL = root.getAttribute("data-gift-pill") || T("gift_pill");
    var IMAGE_POSITION = root.getAttribute("data-image-position") === "above" ? "above" : "below";
    /* Introteksten er styrbar fra temaeditoren. Standardvaerdierne bliver
       staaende her, saa quizzen ogsaa er hel i pop-up-rammen, hvor
       indstillingerne ikke findes. */
    var INTRO_EYEBROW = root.getAttribute("data-intro-eyebrow") || T("intro_eyebrow");
    var INTRO_HEADING = root.getAttribute("data-intro-heading") || T("intro_heading");
    var INTRO_LEDE    = root.getAttribute("data-intro-lede") || T("intro_lede");
    var INTRO_CTA     = root.getAttribute("data-intro-cta") || T("intro_cta");
    var INTRO_IMG = root.getAttribute("data-intro-image") || "";
    var INTRO_IMG_ALT = root.getAttribute("data-intro-image-alt") || "";


    /* ---------- nedtælling (kun pop-up, dækker kun spørgsmål 1 — A2.2) ----------
       Uændret i v2 (addendum 3 §A3.1 punkt 3): uret kører udelukkende
       mens "fact0" står ubesvaret. */
    var TIMER_SECONDS = parseInt(root.getAttribute("data-timer-seconds"), 10);
    if(isNaN(TIMER_SECONDS) || TIMER_SECONDS < 0) TIMER_SECONDS = 120;
    var timerOn = (FRAME === "popup" && TIMER_SECONDS > 0);
    var timerId = null;
    var timerLeft = TIMER_SECONDS;

    function fmtClock(s){
      s = Math.max(0, s);
      var m = Math.floor(s / 60);
      var sec = s % 60;
      return m + ":" + String(sec).padStart(2, "0");
    }
    function stopTimer(){
      if(timerId){ clearInterval(timerId); timerId = null; }
    }
    function startTimer(){
      if(!timerOn) return;
      if(current() !== "fact0" || S.revealed) return;
      stopTimer();
      timerLeft = TIMER_SECONDS;
      updateTimerUI();
      timerId = setInterval(function(){
        timerLeft--;
        if(timerLeft <= 0){
          timerLeft = 0;
          stopTimer();
          S.expired = true;
          render();
          return;
        }
        updateTimerUI();
      }, 1000);
    }
    function updateTimerUI(){
      var strip = root.querySelector(".timer");
      if(!strip) return;
      var clock = strip.querySelector(".clock");
      if(clock) clock.textContent = fmtClock(timerLeft);
      strip.classList.toggle("is-out", timerLeft > 0 && timerLeft <= 20);
    }
    function timerStrip(){
      if(!timerOn || S.expired) return null;
      if(current() !== "fact0" || S.revealed) return null;
      var t = el("div", "timer" + (timerLeft > 0 && timerLeft <= 20 ? " is-out" : ""));
      t.appendChild(el("span","dot"));
      t.appendChild(el("span","lbl",T("time_left")));
      t.appendChild(el("span","clock", fmtClock(timerLeft)));
      return t;
    }

    /* ---------- tilstand ---------- */

    var STEP_START = (FRAME === "popup") ? FLOW.indexOf("fact0") : 0;
    var S;
    var FACT_ORDER = [null, null, null]; /* cache af shufflet rækkefølge pr. spørgsmål */

    function reset(){
      S = {
        step: STEP_START,
        cards: [],     /* valgte card-keys, Q4 */
        who: [],       /* valgte who-keys, Q6 */
        freqIdx: null,
        boxesIdx: null,
        answers: {},   /* fact-idx -> { pickedLabel, correct } */
        revealed:false, picked:null, expired:false, qCount:0
      };
    }
    reset();

    function current(){ return FLOW[S.step]; }
    function go(n){
      S.step = Math.max(STEP_START, Math.min(FLOW.length - 1, S.step + n));
      S.revealed = false; S.picked = null;
      if(current() === "result") stopTimer();
      render();
    }
    function goTo(name){
      var i = FLOW.indexOf(name);
      if(i < 0) return;
      S.step = i;
      S.revealed = false; S.picked = null;
      render();
    }
    /* Tilbage-pil: går ét SPØRGSMÅL tilbage (springer aha-skærme over),
       fra og med spørgsmål 2 — spec DEL 2 "Navigation, progress og gemt
       tilstand". */
    function backOneQuestion(){
      var qi = QUESTION_ORDER.indexOf(current());
      if(qi <= 0) return;
      goTo(QUESTION_ORDER[qi - 1]);
    }
    function canGoBack(){
      var qi = QUESTION_ORDER.indexOf(current());
      return qi > 0;
    }

    /* ---------- hjælpere ---------- */

    function el(tag, cls, html){
      var n = document.createElement(tag);
      if(cls) n.className = cls;
      if(html != null) n.innerHTML = html;
      return n;
    }
    function pane(){
      /* Samme klasse i begge rammer. Da pop-uppen havde sin egen
         (fs__in), skulle HVER komponent have et parallelt regelsaet i
         CSS — det er derfor pop-uppen gen-skinnede sidens design i
         stedet for at arve det. */
      return el("div","quiz__pane");
    }
    /* Alt text (addendum 4 §A4.2 + spec-v2-client.md DEL 2 tilgængelighed):
       describes the object, not the mood — never an empty alt="", since
       these images carry the question's subject, they are not decorative.
       A merchant-supplied image_alt wins; failing that we fall back to
       the question/headline text rather than leaving it blank. */
    function resolveAlt(explicit, fallback){
      var e = (explicit == null) ? "" : String(explicit).trim();
      if(e) return e;
      var f = (fallback == null) ? "" : String(fallback).trim();
      return f || T("illustration");
    }
    /* Delt layout (addendum 4 §A4.2) — nu i BEGGE rammer. Pop-uppen sprang
       det over og viste kun sit baggrundsfoto; den skal matche siden, saa
       spoergsmaalets eget billede hoerer med.
       imgSrc falsy (hide_image sat, eller hverken vaelger eller placeholder)
       kortslutter stadig: intet billede ⇒ ingen tom halvdel. */
    function splitWrap(imgSrc, imgAlt){
      var p = pane();
      if(!imgSrc){
        return { root: p, content: p };
      }
      p.className += " split split--" + IMAGE_POSITION;
      var media = el("div","split__media");
      var img = el("img","split__img");
      img.src = imgSrc;
      img.alt = imgAlt || "";
      img.width = 800;
      img.height = 1000;
      media.appendChild(img);
      var content = el("div","split__content");
      p.appendChild(media);
      p.appendChild(content);
      return { root: p, content: content };
    }
    /* Popup-only wordmark (fullscreen overlay, no theme header behind it).
       The page frame sits inside the theme's own header, which already
       carries the logo — emitting a second one there is a duplicate the
       client asked removed. Returning an empty fragment (not a hidden
       element) means the page frame never even requests the logo image. */
    /* Ingen logo i nogen af rammerne. Siden har det ikke, og pop-uppen
       skal matche den. Et tomt fragment frem for et skjult element, saa
       billedet aldrig hentes. */
    function markEl(){
      return document.createDocumentFragment();
      /* eslint-disable no-unreachable */
      var m = el("div","mark");
      if(LOGO_URL){
        var img = el("img");
        img.src = LOGO_URL;
        img.alt = "Yummii Yummii";
        m.appendChild(img);
      }
      return m;
    }
    function backBtn(){
      var b = el("button","backbtn");
      b.type = "button";
      b.setAttribute("aria-label",T("back"));
      b.innerHTML = '<span aria-hidden="true">←</span>';
      b.addEventListener("click", backOneQuestion);
      return b;
    }

    /* 7-segment fremdriftslinje — begge rammer (addendum 3 §A3.1 punkt 2).
       Aha-skærme (og calc/result) beholder tallet for spørgsmålet før dem. */
    var PROGRESS_FILL = {
      fact0:0, aha0:1, fact1:1, aha1:2, fact2:2, aha2:3,
      cards:3, freq:4, who:5, boxes:6, calc:7, result:7, intro:0
    };
    function progressEl(){
      var filled = PROGRESS_FILL[current()] || 0;
      /* "Current" only marks an actual question screen — on an aha/calc
         screen no single segment is "being answered" right now, so the
         bar just shows what's done (spec: aha screens don't move it). */
      var onQuestion = QUESTION_ORDER.indexOf(current()) > -1;
      var wrap = el("div","progress");
      wrap.setAttribute("role","progressbar");
      wrap.setAttribute("aria-valuemin","0");
      wrap.setAttribute("aria-valuemax","7");
      wrap.setAttribute("aria-valuenow", String(filled));
      wrap.setAttribute("aria-label","Fremgang i quizzen");
      for(var i = 0; i < 7; i++){
        var cls = i < filled ? "is-filled" : (onQuestion && i === filled ? "is-current" : "");
        wrap.appendChild(el("i", cls));
      }
      return wrap;
    }

    function headEl(opts){
      opts = opts || {};
      var head = el("div","head");
      head.appendChild(markEl());
      if(opts.back && canGoBack()) head.appendChild(backBtn());
      if(opts.eyebrow) head.appendChild(el("span","qnum", opts.eyebrow));
      if(opts.sourceLine) head.appendChild(el("p","srcline", opts.sourceLine));
      return head;
    }

    /* single-select button list (freq/boxes) — auto-advances after 250ms
       per spec ("Klik videre automatisk"). */
    function singleList(items, onPick){
      var container = el("ul","opts");
      items.forEach(function(item, i){
        var b = el("button","opt");
        b.type = "button";
        b.setAttribute("data-i", i);
        b.innerHTML = '<span class="opt__key">' + LETTERS[i] + '</span>'
          + '<span class="opt__label">' + item.label + '</span>';
        b.addEventListener("click", function(){ onPick(i, b); });
        var li = el("li"); li.appendChild(b); container.appendChild(li);
      });
      return container;
    }

    /* multi-select button list (who) — text buttons, toggled with a
       trailing "Videre" button, per spec ("Flervalg … har en
       'Videre'-knap"). */
    function multiList(items, selectedKeys, onToggle){
      var container = el("ul","opts");
      items.forEach(function(item, i){
        var isSel = selectedKeys.indexOf(item.key) > -1;
        var b = el("button","opt" + (isSel ? " is-selected" : ""));
        b.type = "button";
        b.setAttribute("aria-pressed", isSel ? "true" : "false");
        b.innerHTML = '<span class="opt__key">' + LETTERS[i] + '</span>'
          + '<span class="opt__label">' + item.label + '</span>'
          + '<span class="opt__check" aria-hidden="true">✓</span>';
        b.addEventListener("click", function(){ onToggle(item.key, b); });
        var li = el("li"); li.appendChild(b); container.appendChild(li);
      });
      return container;
    }

    /* ---------- SKÆRM 0: intro (kun quiz-siden — pop-up'en cold-opener) ----------
       Ingen genoptagelses-banner (klientens beslutning): quizzen starter
       altid forfra. yy_quiz_v1 skrives derfor heller ikke længere nogen
       steder — der er ingen grund til at gemme en tilstand, intet
       læser. */
    function screenIntro(){
      var sw = splitWrap(INTRO_IMG, resolveAlt(INTRO_IMG_ALT, INTRO_HEADING));
      var p = sw.root;
      var c = sw.content;
      /* addendum 4 §A4.1: same pill, same setting, as the pop-up — and
         the 200 kr condition visible in the same view, not first in
         the cart. */
      c.appendChild(el("span","prize", GIFT_PILL));
      c.appendChild(el("p","fine gift-cond", T("gift_cond").replace("[min]", GIFT_MIN)));
      if(INTRO_EYEBROW) c.appendChild(el("p","eyebrow", INTRO_EYEBROW));
      c.appendChild(el("h1",null, INTRO_HEADING));
      if(INTRO_LEDE) c.appendChild(el("p","lede", INTRO_LEDE));
      var a = el("div","actions");
      var b = el("button","btn", INTRO_CTA);
      b.type = "button";
      b.addEventListener("click", function(){ go(1); });
      a.appendChild(b);
      c.appendChild(a);
      c.appendChild(el("p","fine", (SOURCE_LINE || T("sources"))));
      return p;
    }

    /* ---------- AKT 1: gameshow (fact0-2 + aha0-2) ---------- */
    function factOptions(idx){
      var f = FACTS[idx];
      if(!f) return [];
      var items = (f.answers || []).map(function(a, i){ return { label:a.label, correct:!!a.correct, orig:i }; });
      if(idx === 0 || f.randomize === false) return items; /* spørgsmål 1 randomiseres IKKE */
      if(!FACT_ORDER[idx]) FACT_ORDER[idx] = shuffle(items);
      return FACT_ORDER[idx];
    }

    function screenFact(idx){
      var f = FACTS[idx] || {};
      var sw = splitWrap(f.img, resolveAlt(f.imgAlt, f.q));
      var p = sw.root;
      var c = sw.content;
      var head = headEl({ back:true, eyebrow: T("q_of").replace("[n]", idx + 1) });
      if(idx === 0 && SOURCE_LINE){
        head.appendChild(el("p","srcline", SOURCE_LINE));
      }
      if(f.scene) head.appendChild(el("p","qscene", f.scene));
      head.appendChild(el("h2",null, f.q || ""));
      c.appendChild(head);

      var items = factOptions(idx);
      var list = el("ul","opts");
      items.forEach(function(item, i){
        var b = el("button","opt");
        b.type = "button";
        b.innerHTML = '<span class="opt__key">' + LETTERS[i] + '</span>'
          + '<span class="opt__label">' + item.label + '</span>';
        b.addEventListener("click", function(){
          if(S.revealed) return;
          S.revealed = true;
          var isCorrect = !!item.correct;
          S.answers[idx] = { label:item.label, correct:isCorrect };

          if(idx === 0){
            stopTimer();
            var stripEl = root.querySelector(".timer");
            if(stripEl && stripEl.parentNode) stripEl.parentNode.removeChild(stripEl);
          }

          S.qCount++;
          klaviyoTrack("Quiz Besvarelse", {
            spoergsmaal_nr: S.qCount,
            spoergsmaal: f.q,
            svar: item.label,
            korrekt: isCorrect,
            ramme: FRAME
          });

          go(1); /* -> ahaN */
        });
        var li = el("li"); li.appendChild(b); list.appendChild(li);
      });
      c.appendChild(list);
      return p;
    }

    function screenAha(idx){
      var f = FACTS[idx] || {};
      var ans = S.answers[idx] || {};
      var p = pane();
      var head = el("div","head");
      head.appendChild(markEl());
      var heading = ans.correct ? (f.ahaRightHead || T("right")) : (f.ahaWrongHead || f.ahaRightHead || "");
      head.appendChild(el("h2",null, heading));
      p.appendChild(head);

      var body = el("div","aha");
      (f.ahaBody || []).forEach(function(para){
        body.appendChild(el("p",null, para));
      });
      if(f.ahaQuote){
        var q = el("blockquote","aha__quote");
        q.textContent = f.ahaQuote;
        body.appendChild(q);
      }
      if(f.ahaStrong){
        body.appendChild(el("p","aha__strong","<strong>" + f.ahaStrong + "</strong>"));
      }
      if(f.ahaSrc){
        body.appendChild(el("p","aha__src", f.ahaSrc));
      }
      p.appendChild(body);

      var a = el("div","actions");
      var nx = el("button","btn", f.cta || T("next_q"));
      nx.type = "button";
      nx.addEventListener("click", function(){ go(1); });
      a.appendChild(nx);
      p.appendChild(a);
      return p;
    }

    /* ---------- AKT 2: Q4 (billedvalg) + Q5 (frekvens) ---------- */
    function screenCards(){
      var p = pane();
      var head = headEl({ back:true, eyebrow:T("q_of").replace("[n]", 4) });
      head.appendChild(el("h2",null,T("kitchen_h")));
      head.appendChild(el("p","sub",T("kitchen_sub")));
      p.appendChild(head);

      var grid = el("div","cards");
      CARDS.forEach(function(card, i){
        var isSel = S.cards.indexOf(card.key) > -1;
        var b = el("button","card" + (isSel ? " is-selected" : "") + (card.isNone ? " card--none" : ""));
        b.type = "button";
        b.setAttribute("aria-pressed", isSel ? "true" : "false");
        var imgWrap = el("span","card__img");
        if(!card.isNone && card.img){
          var img = document.createElement("img");
          img.src = card.img;
          img.alt = card.alt || card.label;
          img.width = 200; img.height = 200;
          img.decoding = "async";
          imgWrap.appendChild(img);
        } else if(card.isNone){
          imgWrap.appendChild(el("span","card__icon","✓"));
        }
        b.appendChild(imgWrap);
        b.appendChild(el("span","card__label", card.label));
        b.appendChild(el("span","card__check","✓"));
        b.addEventListener("click", function(){
          if(card.isNone){
            S.cards = isSel ? [] : [card.key];
          } else {
            if(isSel){
              S.cards = S.cards.filter(function(k){ return k !== card.key; });
            } else {
              S.cards = S.cards.filter(function(k){
                var c = CARDS.filter(function(cc){ return cc.key === k; })[0];
                return !(c && c.isNone);
              });
              S.cards.push(card.key);
            }
          }
          render();
        });
        grid.appendChild(b);
      });
      p.appendChild(grid);

      var a = el("div","actions cards-actions");
      var nx = el("button","btn",T("next"));
      nx.type = "button";
      nx.disabled = S.cards.length === 0;
      nx.addEventListener("click", function(){
        if(S.cards.length === 0) return;
        S.qCount++;
        klaviyoTrack("Quiz Besvarelse", {
          spoergsmaal_nr: S.qCount,
          spoergsmaal: "Hvad har du stående af de her lige nu?",
          svar: S.cards.join(", "),
          korrekt: null,
          ramme: FRAME
        });
        go(1);
      });
      a.appendChild(nx);
      p.appendChild(a);
      return p;
    }

    function screenFreq(){
      var p = pane();
      var head = headEl({ back:true, eyebrow:T("q_of").replace("[n]", 5) });
      head.appendChild(el("h2",null,T("freq_h")));
      p.appendChild(head);

      if(S.freqConfirm){
        var conf = el("div","why");
        conf.appendChild(el("p","why__text", S.freqConfirm));
        p.appendChild(conf);
        return p;
      }

      var list = singleList(FREQ, function(i, btn){
        var item = FREQ[i];
        S.freqIdx = i;
        S.qCount++;
        klaviyoTrack("Quiz Besvarelse", {
          spoergsmaal_nr: S.qCount,
          spoergsmaal: "Hvor ofte varmer du mad i plast?",
          svar: item.label,
          korrekt: null,
          ramme: FRAME
        });
        if(item.confirm){
          S.freqConfirm = item.confirm;
          render();
          setTimeout(function(){ S.freqConfirm = null; go(1); }, 1400);
        } else {
          setTimeout(function(){ go(1); }, 250);
        }
      });
      p.appendChild(list);
      return p;
    }

    /* ---------- AKT 3: Q6 (hvem) + Q7 (madpakker) ---------- */
    function screenWho(){
      var p = pane();
      var head = headEl({ back:true, eyebrow:T("q_of").replace("[n]", 6) });
      head.appendChild(el("h2",null,T("who_h")));
      p.appendChild(head);

      p.appendChild(multiList(WHO, S.who, function(key){
        var i = S.who.indexOf(key);
        if(i > -1) S.who.splice(i, 1); else S.who.push(key);
        render();
      }));

      var a = el("div","actions");
      var nx = el("button","btn",T("next"));
      nx.type = "button";
      nx.disabled = S.who.length === 0;
      nx.addEventListener("click", function(){
        if(S.who.length === 0) return;
        S.qCount++;
        klaviyoTrack("Quiz Besvarelse", {
          spoergsmaal_nr: S.qCount,
          spoergsmaal: "Hvem er du i gang med at reducere plast og kemi for?",
          svar: S.who.join(", "),
          korrekt: null,
          ramme: FRAME
        });
        go(1);
      });
      a.appendChild(nx);
      p.appendChild(a);
      return p;
    }

    function screenBoxes(){
      var p = pane();
      var head = headEl({ back:true, eyebrow:T("q_of").replace("[n]", 7) });
      head.appendChild(el("h2",null,T("boxes_h")));
      p.appendChild(head);

      var list = singleList(BOXES, function(i){
        var item = BOXES[i];
        S.boxesIdx = i;
        S.qCount++;
        klaviyoTrack("Quiz Besvarelse", {
          spoergsmaal_nr: S.qCount,
          spoergsmaal: "Hvor mange madpakker pakkes der om ugen hos jer?",
          svar: item.label,
          korrekt: null,
          ramme: FRAME
        });
        setTimeout(function(){ go(1); }, 250);
      });
      p.appendChild(list);
      return p;
    }

    /* ---------- SKÆRM 8: beregningen ---------- */
    function screenCalc(){
      var p = pane();
      var head = el("div","head");
      head.appendChild(markEl());
      head.appendChild(el("h2",null,T("calc_h")));
      p.appendChild(head);

      var noneSelected = S.cards.length === 1 && CARDS.some(function(c){ return c.key === S.cards[0] && c.isNone; });
      var n = noneSelected ? 0 : S.cards.length;
      var labels = noneSelected
        ? [T("calc1"),T("calc2"),T("calc3")]
        : [T("calc1n").replace("[n]", n),T("calc2"),T("calc3")];
      var ul = el("ul","steps");
      labels.forEach(function(l){
        var li = el("li","step");
        li.innerHTML = '<span class="step__dot">✓</span><span>' + l + '</span>';
        ul.appendChild(li);
      });
      p.appendChild(ul);
      var track = el("div","calc__track");
      track.appendChild(el("i"));
      p.appendChild(track);

      var items = ul.querySelectorAll(".step");
      var i = 0;
      /* Cirka 2,4 sek. i alt: 3 linjer, ~700ms mellem hver, plus en kort
         start- og slutpause (spec: "Varer 2,4 sekunder"). */
      function tick(){
        if(i > 0) { items[i-1].classList.remove("is-active"); items[i-1].classList.add("is-done"); }
        if(i < items.length){
          items[i].classList.add("is-active");
          i++;
          setTimeout(tick, 700);
        } else {
          setTimeout(function(){ if(current() === "calc") go(1); }, 300);
        }
      }
      setTimeout(tick, 300);
      return p;
    }

    /* ---------- Score + hotspots ---------- */
    function computeScore(){
      var weightSum = 0;
      S.cards.forEach(function(key){
        var c = CARDS.filter(function(cc){ return cc.key === key; })[0];
        if(c && !c.isNone) weightSum += (c.weight || 0);
      });
      var mult = (S.freqIdx != null && FREQ[S.freqIdx]) ? (parseFloat(FREQ[S.freqIdx].multiplier) || 1) : 1;
      return weightSum * mult;
    }
    function isNoneSelected(){
      return S.cards.length === 1 && CARDS.some(function(c){ return c.key === S.cards[0] && c.isNone; });
    }
    function selectedHotspotKeys(){
      if(isNoneSelected()) return [];
      var picked = S.cards.map(function(key){
        return CARDS.filter(function(c){ return c.key === key && !c.isNone; })[0];
      }).filter(Boolean);
      picked.sort(function(a, b){ return (b.weight||0) - (a.weight||0); });
      var keys = picked.map(function(c){ return c.key; });
      /* Q6 "Mine børn" + melamin-kortet valgt -> melamin til plads 1. */
      if(S.who.indexOf("boern") > -1){
        var melIdx = keys.indexOf("service");
        if(melIdx > 0){
          keys.splice(melIdx, 1);
          keys.unshift("service");
        }
      }
      return keys.slice(0, 3);
    }

    /* ---------- SKÆRM 10: resultatet ---------- */
    function screenResult(){
      var score = computeScore();
      var noneSel = isNoneSelected();
      var hotspotKeys = selectedHotspotKeys();

      var doneProps = {
        quiz_version: "evergreen_v2",
        score: score,
        quiz_plast_ting: S.cards,
        quiz_hotspot_1: hotspotKeys[0] || null,
        quiz_hotspot_2: hotspotKeys[1] || null,
        quiz_hotspot_3: hotspotKeys[2] || null,
        quiz_opvarmer_i_plast: (S.freqIdx != null && FREQ[S.freqIdx]) ? FREQ[S.freqIdx].label : null,
        quiz_beskytter: S.who,
        quiz_madpakker_uge: (S.boxesIdx != null && BOXES[S.boxesIdx]) ? BOXES[S.boxesIdx].label : null,
        ramme: FRAME
      };
      klaviyoTrack("Quiz Gennemfoert", doneProps);

      var headline, lede;
      if(noneSel){
        headline = T("r1_h");
        lede = T("r1_l");
      } else if(score >= 9){
        headline = T("r2_h");
        lede = T("r2_l");
      } else if(score >= 4){
        headline = T("r3_h");
        lede = T("r3_l");
      } else {
        headline = T("r4_h");
        lede = T("r4_l");
      }

      var p = pane();
      var head = el("div","head");
      head.appendChild(markEl());
      head.appendChild(el("h2",null, headline));
      head.appendChild(el("p","sub", lede));
      p.appendChild(head);

      /* Gaven staar foerst, ikke sidst. Den er grunden til at kunden
         afleverer sin mail, og den skal derfor ikke ligge under en
         produktbundle man foerst skal scrolle forbi.
         Formular, backend-kald og sporing lever i yy-quiz-lead.js, saa
         denne fil ikke vokser forbi upload-loftet. Falder den fil ud,
         faar kunden stadig sit resultat og et almindeligt klub-link. */
      var giftMin = root.getAttribute("data-gift-min") || "100";
      var gift = window.YYQuizLead && window.YYQuizLead.block({
        root:root, frame:FRAME, clubUrl:CLUB_URL, score:score, giftMin:giftMin,
        hotspots:hotspotKeys, props:doneProps, doneKey:DONE_KEY, state:S
      });
      if(!gift){
        gift = el("div","gift");
        gift.appendChild(el("div","gift__ico","🎁"));
        var gb = el("div","gift__body");
        gb.appendChild(el("span","gift__t",T("join_t")));
        gb.appendChild(el("span","gift__s",T("join_s")));
        gift.appendChild(gb);
        var ga = el("a","btn btn--gold",T("join_cta"));
        ga.href = CLUB_URL;
        gift.appendChild(ga);
        p.appendChild(gift);
        p.appendChild(el("p","fine",T("gift_release").replace("[min]", giftMin)));
      } else p.appendChild(gift);

      if(!noneSel && hotspotKeys.length){
        var sectionHeading = hotspotKeys.length === 1 ? T("hot_one") : T("hot_three");
        p.appendChild(el("p","hotspots__h", sectionHeading));
        var hs = el("div","hotspots");
        hotspotKeys.forEach(function(key){
          var h = HOTSPOTS[key];
          if(!h) return;
          var card = el("div","hotspot");
          card.appendChild(el("p","hotspot__t", h.heading));
          var copy = el("p","hotspot__copy", h.copy);
          if(h.src) copy.appendChild(el("span","hotspot__src", h.src));
          card.appendChild(copy);
          var dest = h.collUrl || h.productUrl;
          if(dest){
            var link = el("a","hotspot__link", h.collUrl ? T("see_range") : T("see_product"));
            link.href = dest;
            card.appendChild(link);
          }
          hs.appendChild(card);
        });
        p.appendChild(hs);

        /* Simple bytteforslag, ikke en bundle. Klienten vil ikke have en
           samlet pris: hvert forslag staar for sig med sin egen pris og sit
           eget link. Produkterne dedupliqueres, fordi flere hotspots nu kan
           pege paa samme startsaet, og den samme vare tre gange ligner en
           fejl frem for en anbefaling. */
        var seen = {}, swaps = [];
        hotspotKeys.forEach(function(k){
          var h = HOTSPOTS[k];
          if(!h) return;
          var dest = h.collUrl || h.productUrl;
          if(!dest || seen[dest]) return;
          seen[dest] = 1;
          swaps.push(h);
        });
        if(swaps.length){
          var sw = el("div","bundle");
          sw.appendChild(el("p","bundle__h", T("how_swap")));
          sw.appendChild(el("p","bundle__sub",T("one_at_a_time")));
          var row = el("div","bundle__row");
          swaps.forEach(function(h){
            var item = el("a","bundle__item");
            /* Kollektionen vinder over produktet. Prisen udelades da, fordi en
               kollektion daekker et spaend og ét tal ville vaere forkert. */
            item.href = h.collUrl || h.productUrl;
            var bild = h.collUrl ? (h.collImg || h.productImg) : h.productImg;
            var navn = h.collUrl ? (h.collTitle || "") : (h.productLabel || "");
            if(bild){
              var img = document.createElement("img");
              img.src = bild; img.alt = navn;
              img.width = 64; img.height = 64; img.decoding = "async";
              item.appendChild(img);
            }
            item.appendChild(el("span","bundle__name", navn));
            if(!h.collUrl && h.price) item.appendChild(el("span","bundle__price", h.price + " kr"));
            row.appendChild(item);
          });
          sw.appendChild(row);
          p.appendChild(sw);
        }
      } else if(noneSel){
        var upgrade = el("div","bundle");
        upgrade.appendChild(el("p","bundle__h",T("upgrade")));
        upgrade.appendChild(el("p","bundle__sub",T("upgrade_sub")));
        var cta2 = el("a","btn bundle__cta",T("see_all"));
        cta2.href = "/collections/rustfrit-stal";
        upgrade.appendChild(cta2);
        p.appendChild(upgrade);
      }

      return p;
    }

    function screenExpired(){
      var p = pane();
      p.className += " expired";
      var head = el("div","head");
      head.appendChild(markEl());
      head.appendChild(el("span","qnum",T("timeout_n")));
      head.appendChild(el("h2",null,T("timeout_h")));
      head.appendChild(el("p","sub",T("timeout_s")));
      p.appendChild(head);
      var a = el("div","actions");
      var b = el("button","btn",T("try_again"));
      b.type = "button";
      b.addEventListener("click", function(){
        reset();
        render();
        startTimer();
      });
      a.appendChild(b);
      p.appendChild(a);
      return p;
    }

    function screenFor(name){
      if(name === "intro")  return screenIntro();
      if(name === "cards")  return screenCards();
      if(name === "freq")   return screenFreq();
      if(name === "who")    return screenWho();
      if(name === "boxes")  return screenBoxes();
      if(name === "calc")   return screenCalc();
      if(name === "result") return screenResult();
      if(name.indexOf("aha") === 0) return screenAha(Number(name.replace("aha","")));
      return screenFact(Number(name.replace("fact","")));
    }

    /* ---------- skaller ---------- */

    function pageInner(){
      /* No logo here (client instruction): the page frame lives inside
         the theme's own header, which already shows the Yummii wordmark.
         A second logo — worse, an unstyled 583x161 one — was a duplicate,
         not a feature. Only the progress bar lives in quiz__top now. */
      var q = el("div","quiz");
      var top = el("div","quiz__top");
      top.appendChild(progressEl());
      q.appendChild(top);

      var scroll = el("div","quiz__scroll");
      var strip = timerStrip();
      if(strip) scroll.appendChild(strip);
      scroll.appendChild(screenFor(current()));
      q.appendChild(scroll);
      return q;
    }

    function render(){
      root.innerHTML = "";
      /* Én opbygning til begge rammer. Pop-uppen traak tidligere .grid
         ud af panet og lagde svarene som et fuldbredde-baand i bunden;
         nu er DOM'en identisk med sidens, og forskellen er ren CSS. */
      root.appendChild(pageInner());
    }

    root.__yyqOnOpen = function(){
      if(S.expired){ reset(); render(); return; }
      startTimer();
    };
    root.__yyqOnClose = stopTimer;

    render();
  }

  function notifyOpen(root){
    if(root && typeof root.__yyqOnOpen === "function") root.__yyqOnOpen();
  }
  function notifyClose(root){
    if(root && typeof root.__yyqOnClose === "function") root.__yyqOnClose();
  }

  function recentlyPlayed(days){
    try{
      var t = localStorage.getItem(DONE_KEY);
      if(!t) return false;
      var age = (Date.now() - new Date(t).getTime()) / 86400000;
      return age < (days || 90);
    }catch(e){ return false; }
  }

  return { mount: mount, recentlyPlayed: recentlyPlayed, notifyOpen: notifyOpen, notifyClose: notifyClose };
})();
